import { configureStore } from '@reduxjs/toolkit';

import configReducer from '../common/redux/slices/configSlice';
import landSearchReducer from '../common/redux/slices/landSearchSlice';
import personalDataReducer from '../common/redux/slices/personalDataSlice';
import paymentReducer from '../common/redux/slices/paymentSlice';
import ProjectSlice from '../common/redux/createproject/createProjectSlice';
import ProjectListSlice from '../common/redux//projectlist/projectListSlice';

const store = configureStore({
  reducer:  {
    config: configReducer,
    payment: paymentReducer,
    personalData: personalDataReducer,
    landSearch: landSearchReducer,
    project: ProjectSlice,
    projectList: ProjectListSlice
    },
  devTools:true,
});

export default store;
